module.exports = __webpack_public_path__ + "static/img/1diamond-card@3x.ae234458.png";